
import React from 'react';

interface BrandLogoProps {
  variant?: 'full' | 'icon';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  forceWhite?: boolean;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({ variant = 'full', size = 'md', className = '', forceWhite = false }) => {
  // Altura da imagem baseada no tamanho solicitado
  const sizeClasses = {
    sm: 'h-6',
    md: 'h-10',
    lg: 'h-12',
    xl: 'h-16'
  };
  
  // Tamanho do texto proporcional
  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-lg',
    lg: 'text-xl',
    xl: 'text-3xl'
  };

  const colorPrimary = forceWhite ? "fill-white" : "fill-[#064E3B] dark:fill-emerald-400";
  const colorSecondary = "fill-[#10B981]";

  return (
    <div className={`flex items-center gap-3 select-none ${className}`}>
      {/* Logo Vetorial "M" Geométrico - Minha Obra */}
      <svg 
        className={`${sizeClasses[size]} w-auto shrink-0`} 
        viewBox="0 0 48 48" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M8 8 L24 24 V42 H8 V8 Z" 
          className={colorPrimary} 
        />
        <path 
          d="M40 8 L24 24 V42 H40 V8 Z" 
          className={colorSecondary} 
        />
      </svg>
      
      {/* Logotipo Texto */}
      {variant === 'full' && (
        <div className={`flex flex-row items-baseline gap-1.5 leading-none ${textSizeClasses[size]}`}>
          <span className={`font-black tracking-tight uppercase ${forceWhite ? 'text-white' : 'text-[#064E3B] dark:text-white'}`}>
            Minha
          </span>
          <span className="font-light tracking-widest uppercase text-[#10B981]">
            Obra
          </span>
        </div>
      )}
    </div>
  );
};
